angular.module('CaresApp').factory('CaseDataService', function($resource) {
  return $resource('api/caseData/:id', {
    id: "@id",
  }, {
  });
});
